export const ATTRIBUTE_ORDER = ["Fire", "Earth", "Water", "Light", "Dark"];

function attributeSortIndex(attribute) {
    const index = ATTRIBUTE_ORDER.indexOf(attribute);
    return index === -1 ? ATTRIBUTE_ORDER.length : index;
}

export function compareAttributeOrder(a, b) {
    return attributeSortIndex(a.attribute) - attributeSortIndex(b.attribute);
}

export function sortByAttributeOrder(items) {
    return [...items].sort((a, b) => {
        const attrDiff = compareAttributeOrder(a, b);
        if (attrDiff !== 0) return attrDiff;
        return String(a.name || "").localeCompare(String(b.name || ""));
    });
}
